import { Component } from "react";
import CarInsurance from "assets/img/insurance.jpeg";

class CarInsuranceBlob extends Component {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  render() {
    return (
      <svg width="100%" id="blobSvg" viewBox="0 0 500 500">
        <defs>
          <clipPath id="shape">
            <path
              id="blob"
              d="M474,316.5Q458,383,403,423.5Q348,464,282.5,473Q217,482,159,451.5Q101,421,66.5,367.5Q32,314,27,248.5Q22,183,65.5,135.5Q109,88,163.5,56.5Q218,25,285.5,24.5Q353,24,406.5,69.5Q460,115,475,182.5Q490,250,474,316.5Z"
              fill="#d1d8e0"
            ></path>
          </clipPath>
        </defs>
        <image
          x="0"
          y="0"
          width="100%"
          height="100%"
          clipPath="url(#shape)"
          xlinkHref={CarInsurance}
          preserveAspectRatio="none"
        />
      </svg>
    );
  }
}

export default CarInsuranceBlob;
